<style lang="scss"  scoped>

</style>

<template>
    <div class="navbar_icon-link navbar_language-selector" data-cover="#lang-selector-cover">
        <div class="ml-2 mr-n1 d-flex">
            <span class="text-theme-color" :class="{'text-white' : separated_colors && !menu_open && theme == 'light'}">
                <span class="pr-1 no-pointers">{{lang.toUpperCase()}}</span>
                <img width="9" class="ml-1 mr-n1 navbar_lang-arrow" alt="icona" :src="'/images/becco-giu-' + theme + '.svg'"/>
            </span>
            <span class="d-flex pl-2 navbar_other-languages">
                <a :href="itUrl" v-if="lang != 'it'" class="pl-2 pr-1 text-theme-color" :class="{'text-white' : separated_colors && !menu_open && theme == 'light'}">IT</a>
                <a :href="enUrl" v-if="lang != 'en'"  class="pl-2 pr-1 text-theme-color" :class="{'text-white' : separated_colors && !menu_open && theme == 'light'}">EN</a>
                <!--<a :href="deUrl" v-if="lang != 'de'"  class="pl-2 pr-1 text-theme-color" :class="{'text-white' : separated_colors && !menu_open && theme == 'light'}">DE</a>-->
            </span>
        </div>
    </div>
</template>
<script>

export default {
    props: ['themeProp', 'lang', 'itUrl', 'deUrl', 'enUrl'],
    data: function () {
        return {
            theme: this.themeProp,
            theme_memo: this.themeProp,
            separated_colors: false,
            menu_open: false,
        };
    },
    mounted() {

        /*if(this.themeProp.split('-').length > 1) {
            this.theme = this.findBreakpointTheme();
            this.$eventHub.$emit('themeChange', this.theme);
        }*/

        if(this.themeProp.split('_').length > 1) {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            if(vw > 991) {
                this.theme = this.themeProp.split('_')[0];
                this.separated_colors = true;
            }else{
                this.theme = 'dark';
                this.separated_colors = false;
            }

        }

        window.addEventListener('resize', () => {

            if (this.themeProp.split('_').length > 1) {
                let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
                if(vw > 991) {
                    this.theme = this.themeProp.split('_')[0];
                    this.separated_colors = true;
                } else {
                    this.theme = 'dark';
                    this.separated_colors = false;
                }

            }
        })

        this.$eventHub.$on('themeChange', (payload) => {
            this.theme = payload;
            this.theme_memo = this.theme;
        });

        this.$eventHub.$on('menuIsOpen', (payload) => {
            if(payload.open) {
                let time = payload.mobile ? 150 : 10
                setTimeout(() => {
                    this.menu_open = true;
                }, time)
                return
            }
            let time = payload.mobile ? 150 : 450
            setTimeout(() => {
                this.menu_open = false;
            }, time)
        });

    },
    methods: {
        findBreakpointTheme() {
            let vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
            let res = null;
            let themes = this.themeProp.split('-');
            if (vw < 576){
                res = 0;
            }else if (vw >= 576 && vw < 768) {
                res = 1;
            }else if (vw >= 768 && vw < 992) {
                res = 2;
            }else if (vw >= 992 && vw < 1199) {
                res = 3;
            }else if (vw >= 1200) {
                res = 4;
            }
            return themes[res];
        },
    },
    beforeDestroy() {
    },
}
</script>
